import React from "react";

const Skills = () => {
  const SKILLS_LIST = [
    {
      label: "HTML5/CSS3 - 95%",
      percentage: "95%",
    },
    {
      label: "Bootstrap5 - 90%",
      percentage: "90%",
    },
    {
      label: "Js/ES6 - 80%",
      percentage: "80%",
    },
    {
      label: "jQuery/ReactJs - 85%",
      percentage: "85%",
    },
    {
      label: "NodeJs - 80%",
      percentage: "80%",
    },
    {
      label: "MySql/MongoDB - 100%",
      percentage: "100%",
    },
  ];
  console.log(SKILLS_LIST);
  const ProgressLine = ({ label, percentage, barBg, progresBg, barHeight }) => {
    const [widths, setWidths] = React.useState(0);

    React.useEffect(() => {
      requestAnimationFrame(() => setWidths(percentage));
    }, [percentage]);

    return (
      <section className="progress-line">
        <span className="progress-line__label">{label}</span>
        <div
          className="progress-line__outer"
          style={{
            background: barBg,
            height: `${barHeight}px`,
          }}
        >
          <div
            className="progress-line__inner"
            style={{
              width: widths,
              background: progresBg,
              transition: "width 2s",
            }}
          />
        </div>
      </section>
    );
  };

  return (
    <div className="skills" id="skills">
      <div className="container text-center">
        <h1 className="title">My Skills</h1>
        <div className="row">
          <div className="col-sm-7 bars">
            {SKILLS_LIST.map(
              (
                skill,
                index // index: static values
              ) => (
                <ProgressLine
                  key={index}
                  barHeight="15"
                  barBg="#efefef"
                  progresBg="linear-gradient(to left, #d400d4, #00ccff)"
                  label={skill.label}
                  percentage={skill.percentage}
                />
              )
            )}
          </div>
          <div className="col-sm-1"></div>
          <div className="col-sm-4">
            <h2>Front-End</h2>
            <ul className="list-unstyled front">
              <li>
                <img src="images/icons8-html-5-48.png" alt="1" />
              </li>
              <li>
                <img src="images/icons8-css3-48.png" alt="2" />
              </li>
              <li>
                <img src="images/icons8-javascript.gif" alt="3" />
              </li>
              <li>
                <img src="images/icons8-bootstrap-48.png" alt="4" />
              </li>
              <li>
                <img src="images/icons8-jquery-50.png" alt="5" />
              </li>
              <li>
                <img src="images/icons8-react-native.gif" alt="6" />
              </li>
            </ul>
            <hr />
            <h2>Back-End</h2>
            <ul className="list-unstyled back">
              <li>
                <img src="images/icons8-nodejs-144.png" alt="7" />
              </li>
              <li>
                <img src="images/icons8-mongodb-144.png" alt="9" />
              </li>
              <li>
                <img src="images/icons8-mysql-logo-144.png" alt="8" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
